import { defineComponent, ref, computed, onMounted, openBlock, createElementBlock, createVNode, unref, normalizeClass, withCtx, createElementVNode, toDisplayString, createBlock, resolveDynamicComponent, createCommentVNode, Fragment, renderSlot } from "vue";
import { IconCheckFill, IconXFill, CdrButton, CdrSkeleton, CdrSkeletonBone } from "@rei/cedar";
const _hoisted_1 = {
  class: "selector-tile"
};
const _hoisted_2 = {
  class: "selector-tile__heading"
};
const _hoisted_3 = {
  class: "selector-tile__heading-text"
};
const _hoisted_4 = {
  class: "selector-tile__timeline"
};
const _hoisted_5 = {
  class: "selector-tile__location"
};
const _hoisted_6 = {
  class: "selector-tile__cost"
};
const _hoisted_7 = {
  class: "selector-tile__cost--emphasis"
};
const _hoisted_8 = {
  class: "selector-tile__change-link"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "GenericSelectorTile",
  props: {
    method: {},
    timeline: {
      default: ""
    },
    location: {
      default: ""
    },
    cost: {
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    },
    footnote: {
      default: ""
    },
    selected: {
      type: Boolean,
      default: false
    },
    isAvailable: {
      type: [Boolean, null],
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    notOffered: {
      type: Boolean,
      default: false
    }
  },
  emits: ["fulfillmentClick", "registerRef"],
  setup(__props, {
    emit: __emit
  }) {
    const button = ref(null);
    const props = __props;
    const emit = __emit;
    const icon = computed(() => props.isAvailable ? IconCheckFill : IconXFill);
    onMounted(() => {
      emit("registerRef", button == null ? void 0 : button.value);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(CdrButton), {
        ref_key: "button",
        ref: button,
        modifier: "secondary",
        class: normalizeClass(["selector-tile__button", {
          "selector-tile__button--selected": _ctx.selected,
          "selector-tile__button--error": _ctx.error,
          "selector-tile__button--not-offered": _ctx.notOffered
        }]),
        "aria-invalid": _ctx.error ? true : null,
        "aria-current": _ctx.selected,
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("fulfillmentClick"))
      }, {
        default: withCtx(() => [createElementVNode("div", _hoisted_2, [createElementVNode("div", _hoisted_3, toDisplayString(_ctx.method), 1), _ctx.selected && _ctx.isAvailable !== null ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["selector-tile__button-icon", {
            "selector-tile__button-icon--unavailable": !_ctx.isAvailable
          }])
        }, [(openBlock(), createBlock(resolveDynamicComponent(icon.value), {
          "inherit-color": ""
        }))], 2)) : createCommentVNode("", true)]), _ctx.isLoading && !_ctx.notOffered ? (openBlock(), createBlock(unref(CdrSkeleton), {
          key: 0
        }, {
          default: withCtx(() => [createVNode(unref(CdrSkeletonBone), {
            class: "selector-tile__skeleton",
            type: "line"
          }), createVNode(unref(CdrSkeletonBone), {
            class: "selector-tile__skeleton",
            type: "line"
          }), createVNode(unref(CdrSkeletonBone), {
            class: "selector-tile__skeleton",
            type: "line"
          })]),
          _: 1
        })) : (openBlock(), createElementBlock(Fragment, {
          key: 1
        }, [createElementVNode("div", _hoisted_4, toDisplayString(_ctx.timeline), 1), createElementVNode("div", _hoisted_5, toDisplayString(_ctx.location), 1), createElementVNode("div", _hoisted_6, [createElementVNode("span", _hoisted_7, toDisplayString(_ctx.cost), 1), createElementVNode("span", null, toDisplayString(_ctx.footnote), 1)])], 64))]),
        _: 1
      }, 8, ["class", "aria-invalid", "aria-current"]), createElementVNode("div", _hoisted_8, [renderSlot(_ctx.$slots, "changeLink", {}, void 0, true)])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=GenericSelectorTile2.mjs.map
